"use strict";

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HttpClient = /*#__PURE__*/function () {
  function HttpClient(httpWrapper, logger) {
    _classCallCheck(this, HttpClient);

    this.httpWrapper = httpWrapper;
    this.logger = logger;
  }

  _createClass(HttpClient, [{
    key: "getPingResponse",
    value: function () {
      var _getPingResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(relayUrl, paymaster) {
        var paymasterSuffix, pingResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                paymasterSuffix = paymaster == null ? '' : '?paymaster=' + paymaster;
                _context.next = 3;
                return this.httpWrapper.sendPromise(relayUrl + '/getaddr' + paymasterSuffix);

              case 3:
                pingResponse = _context.sent;
                this.logger.info("pingResponse: ".concat(JSON.stringify(pingResponse)));

                if (!(pingResponse == null)) {
                  _context.next = 7;
                  break;
                }

                throw new Error('Relay responded without a body');

              case 7:
                return _context.abrupt("return", pingResponse);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPingResponse(_x, _x2) {
        return _getPingResponse.apply(this, arguments);
      }

      return getPingResponse;
    }()
  }, {
    key: "relayTransaction",
    value: function () {
      var _relayTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(relayUrl, request) {
        var _yield$this$httpWrapp, signedTx, error;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.httpWrapper.sendPromise(relayUrl + '/relay', request);

              case 2:
                _yield$this$httpWrapp = _context2.sent;
                signedTx = _yield$this$httpWrapp.signedTx;
                error = _yield$this$httpWrapp.error;
                this.logger.info("relayTransaction response: ".concat(signedTx, ", error: ").concat(error));

                if (!(error != null)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("Got error response from relay: ".concat(error));

              case 8:
                if (!(signedTx == null)) {
                  _context2.next = 10;
                  break;
                }

                throw new Error('body.signedTx field missing.');

              case 10:
                return _context2.abrupt("return", signedTx);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function relayTransaction(_x3, _x4) {
        return _relayTransaction.apply(this, arguments);
      }

      return relayTransaction;
    }()
  }, {
    key: "auditTransaction",
    value: function () {
      var _auditTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(relayUrl, signedTx) {
        var auditRequest, auditResponse;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                auditRequest = {
                  signedTx: signedTx
                };
                _context3.next = 3;
                return this.httpWrapper.sendPromise(relayUrl + '/audit', auditRequest);

              case 3:
                auditResponse = _context3.sent;
                this.logger.info("auditTransaction response: ".concat(JSON.stringify(auditResponse)));
                return _context3.abrupt("return", auditResponse);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function auditTransaction(_x5, _x6) {
        return _auditTransaction.apply(this, arguments);
      }

      return auditTransaction;
    }()
  }]);

  return HttpClient;
}();

exports.HttpClient = HttpClient;